import script from "./DataResidencyBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./DataResidencyBadge.vue?vue&type=script&setup=true&lang=js"

import "./DataResidencyBadge.vue?vue&type=style&index=0&id=3f7b6d1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f7b6d1a"]])

export default __exports__